import footer from './index.vue'
footer.install = Vue => Vue.component(footer.name, footer)
export default footer
